<div class="news" *ngFor="let newsArticle of newsArticles;">
    <div class="container">
        <img src={{newsArticle.path}} alt="Avatar" class="image">
    </div>
    <div #a class="newsBox">
        <p class="newsHeader">{{newsArticle.title}}</p> 
       <p class="newsText">{{newsArticle.text}}</p>
    </div>
</div>